import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KeyValue } from '@angular/common';

import { Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { DynamicFormCommonConfig, FormContentResponse } from 'zr-dynamic-form/dynamic-form-common';

import { ControlShared } from '../utils';
import { ControlBroadCastEvent } from '../types';
import { RemoteDataSourceService } from './remote-data-source.service';
import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';

@Injectable({
  providedIn: 'root'
})
export class ControlSharedService implements ControlShared {
  remoteDataSourceService: RemoteDataSourceService;
  commonConfig: DynamicFormCommonConfig;
  designerConfig: DynamicFormDesignerConfig;

  private _globalDataChange: Subject<any>;
  private _controlBroadCast: Subject<ControlBroadCastEvent>;
  private formContentsCache: KeyValue<string, Observable<FormContentResponse>>[] = [];

  constructor(
    _remoteDataSourceService: RemoteDataSourceService,
    _commonConfig: DynamicFormCommonConfig,
    _designerConfig: DynamicFormDesignerConfig,
    private httpClient: HttpClient
  ) {
    this._globalDataChange = new Subject<any>();
    this._controlBroadCast = new Subject<ControlBroadCastEvent>();
    this.remoteDataSourceService = _remoteDataSourceService;
    this.commonConfig = _commonConfig;
    this.designerConfig = _designerConfig;
  }

  isDesign: boolean;

  globalData: any;

  get globalDataChange(): Observable<any> {
    return this._globalDataChange.asObservable();
  }
  sendGlobalDataChange(data: any): void {
    this.globalData = data;
    this._globalDataChange.next(data);
  }

  get controlBroadCasted$(): Observable<ControlBroadCastEvent> {
    return this._controlBroadCast.asObservable();
  }
  controlBroadCasted(event: ControlBroadCastEvent): void {
    this._controlBroadCast.next(event);
  }

  getFormContent(formCode: string, labelCode: string): Observable<FormContentResponse> {
    const getContent = () => {
      const contentUrl = `${this.getFormDataUrl()}/published/content`;
      return this.httpClient.get<FormContentResponse>(contentUrl, {
        params: { formCode, labelCode }
      });
    };

    if (this.isDesign) {
      return getContent();
    }

    const key = formCode + '&&' + labelCode;

    const formContent = this.formContentsCache.find((s) => s.key === key);
    if (formContent) {
      return formContent.value;
    }

    const formContent$ = getContent();
    const subject = formContent$.pipe(shareReplay(1));
    this.formContentsCache.push({ key, value: subject });
    subject.subscribe((s) => {});
    return subject;
  }

  private getFormDataUrl() {
    return `${this.designerConfig.serviceUrl}dynamicform/formdatas`;
  }
}
